import React, { Component } from "react";
import { Button, Input } from "antd";
import { FaFilter, FaSearch, FaPlus, FaUserPlus } from "react-icons/fa";
import "./TabHeader.scss";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
const { Search } = Input;
const suffix = (
  <FaSearch
    style={{
      fontSize: 20,
      color: "#939598",
    }}
  />
);
class TabHeader extends Component {
  renderSwitch = (param = "order") => {
    switch (param) {
      case "order":
        return (
          <>
            {/* <Button
              type="primary"
              onClick={this.props.handelShowFilter}
              icon={<FaFilter />}
            >
              تصفيه
            </Button> */}
            <Link to="/cars">
              <Button
                type="primary"
                className="blue-btn  new-order-btn"
                icon={<FaPlus />}
              >
                طلب جديد
              </Button>
            </Link>
          </>
        );
      case "bonds":
        return (
          <>
            <Button
              type="primary"
              onClick={this.props.handelShowFilter}
              icon={<FaFilter />}
            >
              تصفيه
            </Button>
            {/* <Button type="primary" className="blue-btn" icon={<FaFileContract />} onClick={() => {this.props.history.push("/new-bond")}}>
                    سند جديد
                </Button> */}
          </>
        );
      case "contact":
        return (
          <>
            <Button
              type="primary"
              onClick={this.props.handelShowFilter}
              icon={<FaFilter />}
            >
              تصفيه
            </Button>
            <Link to="/cars">
              <Button type="primary" className="blue-btn new-order-btn">
                <FaPlus />
                طلب جديد
              </Button>
            </Link>
          </>
        );
      case "upload":
        return (
          <>
            <Button
              type="primary"
              onClick={this.props.handelShowFilter}
              icon={<FaFilter />}
            >
              تصفيه
            </Button>
          </>
        );
      case "teams":
        return (
          <>
            <Button type="primary" className="blue-btn">
              <Link to="/add-team">
                <FaPlus />
                فريق جديد
              </Link>
            </Button>
            <Button type="primary" className="blue-btn">
              <Link to="/add-employee">
                <FaPlus />
                موظف جديد
              </Link>
            </Button>
          </>
        );
      default:
        return (
          <>
            <Button
              type="primary"
              onClick={this.props.handelShowFilter}
              icon={<FaFilter />}
            >
              تصفيه
            </Button>
            <Button
              type="primary"
              onClick={this.props.handelShowAdmin}
              className="blue-btn"
              icon={<FaUserPlus />}
            >
              تعيين
            </Button>
          </>
        );
    }
  };

  onSearch = (value) => console.log(value);
  render() {
    const { title, showType, onSearchUSerOrder } = this.props;
    return (
      <div className="order-tabs-header">
        <div className="order-header-content">
          <h1>{title}</h1>
          <div className="order-header-search">
            <Search
              placeholder=" البحث برقم الطلب"
              // enterButton="Search"
              size="large"
              prefix={suffix}
              onSearch={onSearchUSerOrder}
            />
            <div className="header-search-action">
              {this.renderSwitch(showType)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const TabHeaderWithRouter = withRouter(TabHeader);
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});
export default connect(mapStateToProps)(TabHeaderWithRouter);
